import React, { Component } from "react";

import "./conecta-consulta.css";

import AppContext from "../appContext";
import Back from "../main/back";
import Input from "../components/inputs/input";
import Select from "../components/selects/select";
import ConsultaInputDate from "./consulta-inputs/consulta-input-date";
import ConsultaSearchButton from "./consulta-inputs/consulta-search-button";
import ConsultaTableHead from "./consulta-table/consulta-table-head";
import { getConectaPedidos } from "../Functions/gestao-pedidos-laboratorios/get-conecta-pedidos";
import { getCampanha } from "../Functions/campanha/get-campanha";
import { get_configuracao_laboratorio_og } from "../Functions/Laboratorio/get_configuracao_lab_og";
import CnpjUtils from "../shared/utils/CnpjUtils";

import { Box, Container, Typography } from "@material-ui/core";
import { Redirect } from "react-router-dom";
import Moment from "moment";
import Swal from "sweetalert2";

const LIMITE_PADRAO = 20;
const OPCOES_PAR = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
];
const MODULO_CONECTA_CONSULTA = "Conecta Consulta";
const MENSAGEM_LAB_NAO_HABILITADO = "Este laboratório ainda não está habilitado a receber pedidos pelo Essilor Conecta.";

const inicio60Dias = () => new Date(new Date().setDate(new Date().getDate() - 60));

class ConectaConsulta extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cnpj_otica: "",
      cnpj_laboratorio: "",
      pedido_essilor: "",
      pedido_otica: "",
      dia_inicio: inicio60Dias(),
      dia_fim: new Date(),
      data_inicio: Moment(inicio60Dias()).format("YYYY-MM-DD"),
      data_fim: Moment(new Date()).format("YYYY-MM-DD"),
      cupom: "",
      campanha: "",
      campanha_lista: [],
      par_cupom: "",
      pedidos: [],
      paginaAtual: 1,
      paginaTotal: 1,
      quantidadeTotal: 0,
      resposta_tabela: false,
      loading: false,
      redirect: false,
      redirectL: false,
      lab: null,
      open: "",
      arrow: "",
    };

    if (sessionStorage.getItem("token") !== null) {
      ConectaConsulta.contextType = AppContext;
      const modulos = ConectaConsulta.contextType._currentValue.userSession.modulos || [];
      const temAcesso = modulos.includes(MODULO_CONECTA_CONSULTA);
      if (!temAcesso) {
        this.state.redirect = true;
      }
    } else {
      this.state.redirectL = true;
    }
  }

  async componentDidMount() {
    if (this.state.redirect || this.state.redirectL) return;
    this.fetchCampanhas();
    // Essilor entra sem laboratório definido: não busca nem carrega lab até informar o CNPJ.
    if (this.isEssilor()) return;
    if (!(await this.laboratorioHabilitado())) return;
    this.fetchLab(this.context.userSession.conta);
    this.buscar(1);
  }

  async laboratorioHabilitado() {
    this.context.showLoading();
    const configuracao = await get_configuracao_laboratorio_og(this.laboratorioConsulta());
    this.context.hideLoading();
    if (!configuracao || configuracao.laboratorioHabilitado) return true;
    await this.aviso(MENSAGEM_LAB_NAO_HABILITADO);
    this.setState({ redirect: true });
    return false;
  }

  async fetchCampanhas() {
    try {
      const resposta = await getCampanha();
      this.setState({ campanha_lista: (resposta && resposta.items && resposta.items.campanha) || [] });
    } catch (error) {
      this.setState({ campanha_lista: [] });
    }
  }

  isEssilor() {
    return this.context.userSession.papelCategoria === "ESSILOR";
  }

  async fetchLab(cnpj) {
    if (!cnpj) return;
    const conta = this.context.userSession.conta;
    try {
      const response = await fetch(process.env.REACT_APP_LABS_API + "get_labs.php", {
        method: "POST",
        body: JSON.stringify({ cnpjs: [cnpj], papel: this.context.userSession.papel, conta }),
      });
      const json = await response.json();
      const item = (json.items || []).find(i => CnpjUtils.cleanCnpj(i.CNPJ_c) === CnpjUtils.cleanCnpj(cnpj));
      if (item) {
        this.setState({
          lab: {
            nome: item.Nome_c,
            cnpj: item.CNPJ_c,
            logo: item.URL_Logo_c,
            telefone: item.Telefone_c,
            email: item.Email_c,
            site: item.Site_c,
          },
        });
        return;
      }
      // Sem registro no get_labs (sem logo/contato): mostra o nome do laboratório (estilizado como logo).
      const accResp = await fetch(process.env.REACT_APP_LABS_API + "get_account_data.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cnpj }),
      });
      const accJson = await accResp.json();
      this.setState({
        lab: accJson && (accJson.fantasia || accJson.nome) ? { nome: accJson.fantasia || accJson.nome, cnpj } : null,
      });
    } catch (error) {
      this.setState({ lab: null });
    }
  }

  laboratorioConsulta() {
    if (this.isEssilor()) return CnpjUtils.cleanCnpj(this.state.cnpj_laboratorio);
    return CnpjUtils.cleanCnpj(this.context.userSession.conta);
  }

  handleChange = e => {
    const name = e.target.getAttribute("name");
    this.setState({ [name]: e.target.value });
  };

  handleChangeCnpj = e => {
    const name = e.target.getAttribute("name");
    const clean = CnpjUtils.cleanCnpj(e.target.value).slice(0, 14);
    this.setState({ [name]: clean });
  };

  handleChangeDataInicio = date => {
    this.setState({ dia_inicio: date, data_inicio: date ? Moment(date).format("YYYY-MM-DD") : "" });
  };

  handleChangeDataFim = date => {
    this.setState({ dia_fim: date, data_fim: date ? Moment(date).format("YYYY-MM-DD") : "" });
  };

  aviso(text) {
    return Swal.fire({ text, title: "Aviso", icon: "warning", confirmButtonColor: "#3085d6", confirmButtonText: "Ok" });
  }

  validar() {
    if (this.isEssilor()) {
      if (!this.state.cnpj_laboratorio) {
        this.aviso("Informe o CNPJ do Laboratório.");
        return false;
      }
      if (CnpjUtils.cleanCnpj(this.state.cnpj_laboratorio).length !== 14) {
        this.aviso("Informe o CNPJ do Laboratório completo.");
        return false;
      }
    }
    if (this.state.cnpj_otica && CnpjUtils.cleanCnpj(this.state.cnpj_otica).length !== 14) {
      this.aviso("Informe o CNPJ da ótica buscada completo.");
      return false;
    }
    if (this.state.pedido_essilor && this.state.pedido_otica) {
      this.aviso("Redefina a busca preenchendo o Pedido Essilor OU o Pedido Ótica.");
      return false;
    }
    if (!this.state.data_inicio || !this.state.data_fim) {
      this.aviso("Por favor, informe um período válido (data de início e data final).");
      return false;
    }
    if (this.state.data_inicio > this.state.data_fim) {
      this.aviso("Período da busca inválido: data inicial maior que data final.");
      return false;
    }
    return true;
  }

  buscar = async (pagina = 1) => {
    if (!this.validar()) return;

    if (this.isEssilor()) this.fetchLab(this.state.cnpj_laboratorio);

    this.setState({ loading: true });
    this.context.showLoading("Buscando pedidos...");

    const resultado = await getConectaPedidos({
      laboratorio: this.laboratorioConsulta(),
      cnpjOtica: this.state.cnpj_otica,
      pedidoEssilor: this.state.pedido_essilor,
      pedidoOtica: this.state.pedido_otica,
      dataInicio: this.state.data_inicio,
      dataFim: this.state.data_fim,
      cupom: this.state.cupom,
      campanha: this.state.campanha,
      parCupom: this.state.par_cupom,
      pagina,
      limite: LIMITE_PADRAO,
    });

    this.context.hideLoading();
    this.setState({ loading: false });

    if (resultado.status === 401) {
      this.setState({ redirectL: true });
      return;
    }
    if (resultado.status === 403) {
      this.aviso(resultado.erro || "Consulta permitida somente para o laboratório da conta.");
      return;
    }
    if (resultado.status === 0 || resultado.status >= 400) {
      this.aviso(resultado.erro || "Tivemos uma falha momentânea de comunicação. Tente novamente.");
      return;
    }

    if (resultado.pedidos.length === 0) {
      this.setState({ pedidos: [], paginaAtual: 1, paginaTotal: 1, quantidadeTotal: 0, resposta_tabela: true });
      return;
    }

    this.setState(
      {
        pedidos: resultado.pedidos,
        paginaAtual: resultado.paginaAtual,
        paginaTotal: resultado.paginaTotal,
        quantidadeTotal: resultado.quantidadeTotal,
        resposta_tabela: true,
      },
      () => {
        if (this.myRef) window.scrollTo(0, this.myRef.offsetTop);
      }
    );
  };

  onPageChange = pagina => {
    this.buscar(pagina);
  };

  openSummary = () => {
    this.setState(prev => (prev.open ? { open: "", arrow: "" } : { open: "show-summary", arrow: "active-arrow" }));
  };

  labNome() {
    return this.state.lab?.nome || this.context.apelidoConta || this.context.ownerName || "";
  }

  render() {
    if (this.state.redirect) return <Redirect to="/home" />;
    if (this.state.redirectL) return <Redirect to="/" />;

    return (
      <main className="main-consulta">
        <div className={this.state.loading ? "Opacity" : "Nopacity"} id="main-tabela-consulta">
          <Back />
          <Container maxWidth="lg" disableGutters>
            <div className="title-container">
              <h1 className="main-title">Consulte seus pedidos recebidos no Essilor Conecta</h1>
              <span className="title-shape"></span>
            </div>
            <div className="subtitle-container">
              <p className="subtitle">Consulte pedidos enviados no Essilor Conecta para o seu laboratório.</p>
            </div>

            <div className="row">
              <div className="col-xs-12 col-md-6">
                <Input
                  type="text"
                  label="CNPJ da ótica buscada"
                  width="100%"
                  name="cnpj_otica"
                  value={CnpjUtils.formatCnpj(this.state.cnpj_otica)}
                  onChange={this.handleChangeCnpj}
                  placeholder="XX.XXX.XXX/XXXX-XX"
                  maxlength="18"
                  autocomplete="off"
                  tooltip="CNPJ da ótica que deseja buscar."
                />
              </div>
              {this.isEssilor() && (
                <div className="col-xs-12 col-md-6">
                  <Input
                    type="text"
                    label="CNPJ do Laboratório *"
                    width="100%"
                    name="cnpj_laboratorio"
                    value={CnpjUtils.formatCnpj(this.state.cnpj_laboratorio)}
                    onChange={this.handleChangeCnpj}
                    onBlur={() => this.fetchLab(this.state.cnpj_laboratorio)}
                    placeholder="XX.XXX.XXX/XXXX-XX"
                    maxlength="18"
                    autocomplete="off"
                  />
                </div>
              )}
            </div>

            <div className="row mt-4">
              <div className="col-xs-12 col-md-3 consulta-col-essilor">
                <Input
                  type="text"
                  label="Pedido Essilor"
                  width="100%"
                  name="pedido_essilor"
                  value={this.state.pedido_essilor}
                  onChange={this.handleChange}
                  disabled={!!this.state.pedido_otica}
                />
              </div>
              <div className="col-xs-12 col-md-1 text-center pt-3 consulta-col-ou">
                <span className="consulta-filters-text">OU</span>
              </div>
              <div className="col-xs-12 col-md-3 consulta-col-otica">
                <Input
                  type="text"
                  label="Pedido Ótica"
                  width="100%"
                  name="pedido_otica"
                  value={this.state.pedido_otica}
                  onChange={this.handleChange}
                  disabled={!!this.state.pedido_essilor}
                  tooltip="Número de controle enviado pela ótica."
                />
              </div>
              <div className="col-xs-12 col-md-5">
                <ConsultaInputDate
                  dia_inicio={this.state.dia_inicio}
                  dia_fim={this.state.dia_fim}
                  onChange_inicio={this.handleChangeDataInicio}
                  onChange_fim={this.handleChangeDataFim}
                />
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-xs-12 col-md-4">
                <Input type="text" label="Cupom" width="100%" name="cupom" value={this.state.cupom} onChange={this.handleChange} />
              </div>
              <div className="col-xs-12 col-md-4">
                <Select
                  label="Campanha"
                  width="100%"
                  placeholder="Selecione"
                  itens={this.state.campanha_lista}
                  name="campanha"
                  value={this.state.campanha}
                  onChange={this.handleChange}
                />
              </div>
              <div className="col-xs-12 col-md-4">
                <Select
                  label="Par do Cupom"
                  width="100%"
                  placeholder="Selecione"
                  itens={OPCOES_PAR}
                  name="par_cupom"
                  value={this.state.par_cupom}
                  onChange={this.handleChange}
                />
              </div>
            </div>

            <Box mt={5} display="flex" justifyContent="center">
              <ConsultaSearchButton onClick={() => this.buscar(1)} />
            </Box>

            <section ref={ref => (this.myRef = ref)} className="mt-4">
              {this.state.resposta_tabela &&
                (this.state.pedidos.length > 0 ? (
                  <ConsultaTableHead
                    pedidos={this.state.pedidos}
                    paginaAtual={this.state.paginaAtual}
                    paginaTotal={this.state.paginaTotal}
                    onPageChange={this.onPageChange}
                    laboratorio={this.laboratorioConsulta()}
                  />
                ) : (
                  <div className="noReponse">
                    <p className="consulta-empty text-center">Nenhum pedido encontrado para o período informado.</p>
                  </div>
                ))}
            </section>
          </Container>
        </div>

        <div className={`x-web-ordering-pedido__summary_LentePronta ${this.state.open}`} style={{ background: "#f3f3f5", minHeight: "400px" }}>
          <div className={`lp-summary--arrowContainer ${this.state.arrow}`} onClick={this.openSummary}>
            <span id="btn-toggle-resumo" className={`lp-summary--arrow ${this.state.arrow}`} onClick={this.openSummary}></span>
          </div>
          <div className={`row x-web-ordering-pedido__summary--container ${this.state.arrow}`}>
            <div className="col-12">
              <div className="x-user-consultant__left">
                <h1 className="x-user-consultant__title consulta-resumo-logo">
                  <img src="image/modulos/Conecta_Consulta_transparente.png" width="45%" alt="Conecta Consulta" />
                </h1>
              </div>
            </div>

            {this.state.lab && (
              <>
                <div className="col-12">
                  <Typography variant="subtitle1" style={{ color: "#00518b", fontSize: "1rem", fontWeight: 500 }}>
                    Laboratório:
                  </Typography>
                </div>
                <div className="logolabTracking col-12 my-4">
                  {this.state.lab.logo ? (
                    <img src={this.state.lab.logo} width="178" height="120" alt="Logo laboratório" />
                  ) : (
                    <span className="consulta-lab-nome">{this.state.lab.nome}</span>
                  )}
                </div>
                {(this.state.lab.telefone || this.state.lab.email || this.state.lab.site) && (
                  <div className="col-12 mt-3">
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: "#00518b" }}>
                      Dúvidas? Entre em contato com o laboratório
                    </Typography>
                    {this.state.lab.telefone && (
                      <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
                        <strong>Telefone:</strong> {this.state.lab.telefone}
                      </Typography>
                    )}
                    {this.state.lab.email && (
                      <Typography variant="body2" color="textSecondary" style={{ marginTop: 2 }}>
                        <strong>Email:</strong> {this.state.lab.email}
                      </Typography>
                    )}
                    {this.state.lab.site && (
                      <Typography variant="body2" color="textSecondary" style={{ marginTop: 2 }}>
                        <strong>Site:</strong> {this.state.lab.site}
                      </Typography>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </main>
    );
  }
}

export default ConectaConsulta;
